export default {
  tiles: [
    {
      preheader: 'For employers',
      title: 'Join the Pledge',
      content:
        'Ready to make an impact through a CDCU investment? Click [here](mailto:socialimpact@nerdwallet.com) to get connected.',
      icon: 'https://assets.nerdwallet.com/blog/wp-content/uploads/2023/06/join-the-pledge.png',
      altImage: 'Join the Pledge',
    },
    {
      preheader: 'For nonprofits',
      title: 'Partner in Volunteering',
      content:
        'In 2022, NerdWallet employees volunteered more than 3,500 hours for causes they care about. If you’d like to set up a volunteering program with NerdWallet, [reach out here](mailto:socialimpact@nerdwallet.com)',
      icon: 'https://assets.nerdwallet.com/blog/wp-content/uploads/2023/06/partner-in-volunteering.png',
      altImage: 'Partner in Volunteering',
    },
    {
      preheader: 'For employees',
      title: 'Motivate Leadership',
      content:
        'Download [this](https://www.nerdwallet.com/corporate-social-responsibility/email) form and ask your leadership team to consider investing in The Financial Equity Pledge.',
      icon: 'https://assets.nerdwallet.com/blog/wp-content/uploads/2023/06/motivate-leadership.png',
      altImage: 'Motivate Leadership',
    },
  ],
};
